import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent, ButtonType, DialogHeaderComponent, TextareaFormFieldComponent } from '@pgaoc/shared-lib';

@Component({
  imports: [ButtonComponent, DialogHeaderComponent, ReactiveFormsModule, TextareaFormFieldComponent],
  templateUrl: './reject-dialog.component.html',
  styleUrl: './reject-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RejectDialogComponent {
  protected readonly ButtonType = ButtonType;
  private dialogRef = inject(MatDialogRef<RejectDialogComponent>);

  protected readonly reasonForRejectionFormControl = new FormControl<string>('', {
    nonNullable: true,
  });
  protected readonly isSubmitted = signal<boolean>(false);

  updateToRejectedClicked() {
    this.isSubmitted.set(true);
    if (this.reasonForRejectionFormControl.invalid) return;
    this.dialogRef.close(this.reasonForRejectionFormControl.value);
  }

  closeClicked() {
    this.dialogRef.close();
  }
}
